import React, { FC, ReactNode, createContext, useContext, useMemo, useReducer } from 'react';
import { AppState, UseAppContext } from './types';
import { Reducer, initialState } from './reducer';

export const AppContext = createContext<AppState>(null);
AppContext.displayName = 'AppState';

export const AppContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  const context = useMemo<AppState>(() => ({ state, dispatch }) as unknown as AppState, [state, dispatch]);

  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext<AppState>(AppContext) as unknown as UseAppContext;
